import { RefObject, useRef } from "react";
import { RefFilterSelected } from "../../components/dinamicForm/filterSelect/props";

const useDinamicFormRefs = () => {
  const ref = useRef<{ filterSelected: RefObject<RefFilterSelected> }>(null);

  return {ref}
}

export { useDinamicFormRefs }